var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandGitLabStyleBlack = function SvgBrandGitLabStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#svg_icon_BrandGitLabStyleBlack__clip0_1439_24006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.431 20.356 3.952 2.996a1.01 1.01 0 0 0 1.22 0l3.957-2.997-4.569-3.452zM23.596 9.584l-.033-.086a11.1 11.1 0 0 0-4.392 1.975l-7.165 5.43 4.569 3.452 5.005-3.747.014-.01a6.07 6.07 0 0 0 2.002-7.014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.826 11.478c-1.3-.973-2.8-1.647-4.391-1.974L.4 9.59a6.07 6.07 0 0 0 2.009 7.01l.012.009.029.022 4.976 3.725 4.58-3.452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.034 16.925-.028-.022 7.165-5.43a11.1 11.1 0 0 1 4.392-1.975L20.3.985a.85.85 0 0 0-.847-.538.854.854 0 0 0-.784.627l-2.206 6.75H7.538l-2.206-6.75A.85.85 0 0 0 4.55.445a.865.865 0 0 0-.848.54L.436 9.505c1.591.327 3.09 1 4.39 1.973l7.18 5.425-.007.006.027.021z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandGitLabStyleBlack__clip0_1439_24006"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandGitLabStyleBlack);
export { ForwardRef as ReactComponent };